import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BaseConfig,
  EnvironmentConfiguration,
  ReportingConfiguration,
  UserConfiguration,
} from '@rx-applications/clientsite/shared/config/utils';
import { RecentlyBookedHotel } from '@rx-applications/clientsite/shared/config/utils';

export const envConfigActions = createActionGroup({
  source: 'Config App',
  events: {
    'Load Environment': emptyProps(),
    'Load Environment Succeed': props<{ environmentConfiguration: EnvironmentConfiguration }>(),
    'Load Environment Failed': props<{ error: Error }>(),
    'Prepare Environment Rxwebapi': props<{ baseConfig: BaseConfig }>(),
    'Update Environment Rxwebapi': props<{ rxwebapi: string, baseConfig: BaseConfig }>(),    
  },
});

export const baseConfigActions = createActionGroup({
  source: 'Config App',
  events: {
    'Load Base Config': emptyProps(),
    'Load Base Config Succeed': props<{ baseConfig: BaseConfig }>(),
    'Load Base Config Failed': props<{ error: Error }>(),
  },
});

export const localeActions = createActionGroup({
  source: 'Config App',
  events: {
    'Initialize Locale': emptyProps(),
    'Initialize Locale Succeed': props<{ newLocale: string }>(),
    'Change Locale': props<{ newLocale: string }>(),
    'Change Locale Succeed': props<{ newLocale: string }>(),
  },
});

export const clientConfig = createActionGroup({
  source: 'Client Config',
  events: {
    Load: emptyProps(),
    'Load Success': props<{ configuration: UserConfiguration }>(),
    'Load Failed': props<{ error: Error }>(),
  },
});

export const analyticsConfig = createActionGroup({
  source: 'Analytics Config',
  events: {
    Load: emptyProps(),
    'Load Success': props<{ reportingConfiguration: ReportingConfiguration }>(),
    'Load Failed': props<{ error: Error }>(),
  },
});

export const cidActions = createActionGroup({
  source: 'Config App',
  events: {
    'Generate CID Succeed': props<{ guid: string }>(),
    'Read CID Succeed': props<{ guid: string }>(),
  },
});

export const setSelectedCurrency = createAction('[User Settings] Set Selected Currency', props<{ payload: string }>());

export const initializeCurrentCurrency = createAction(
  '[User Settings] Initialize Current Currency',
  props<{ payload: string }>(),
);

export const initializeCurrentCurrencySucceed = createAction(
  '[User Settings] Initialize Current Currency Succeed',
  props<{ payload: string }>(),
);

export const updateRecentlyBookedHotel = createAction(
  '[Guest Details Effect] Update Recently Booked Hotels',
  props<{ recentlyBookedHotel: RecentlyBookedHotel }>(),
);

export const validateWebsite = createAction('[Config API] Validate WebsiteId');
